import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormArray,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { isArray, transformTitle } from 'src/app/helper/class/utilityHelper';
import {
  formBuilderData,
  formValidator,
} from 'src/app/helper/interface/response';

@Component({
  selector: 'app-form-array',
  templateUrl: './form-array.component.html',
  styleUrls: ['./form-array.component.scss'],
})
export class FormArrayComponent {
  @Input() parentForm!: UntypedFormGroup;
  @Input() arrayName!: string; // e.g., 'conditions'
  @Input() fields: formBuilderData[] = [];
  @Input() title: string = '';
  @Output() onArrayChange = new EventEmitter<any>();
  dummyControl: any;
  formArray!: UntypedFormArray;

  constructor(private ref: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (!this.parentForm) {
      throw new Error('Parent FormGroup is required.');
    }

    this.formArray = this.parentForm.get(this.arrayName) as UntypedFormArray;
    if (!this.formArray) {
      this.formArray = new UntypedFormArray([]);
      this.parentForm.addControl(this.arrayName, this.formArray);
    }

    if (this.formArray.length === 0) {
      this.addRow();
    }
  }

  createFormGroup(): UntypedFormGroup {
    const group: any = {};
    this.fields.forEach((f) => {
      const v = this.transformValidator(
        f.validator || [],
        f.title || f.colName
      );
      const title = f.title
        ? transformTitle(f.title)
        : transformTitle(f.colName);
      group[f.colName] = new UntypedFormControl(f.defaultValue || '', v);
    });
    return new UntypedFormGroup(group);
  }

  transformValidator(validator: formValidator[] = [], title = '') {
    const v: any = [];
    if (isArray(validator)) {
      validator.forEach((b: formValidator) => {
        const arrayFunVal = ['pattern', 'minLength', 'maxLength', 'min', 'max'];
        const s = arrayFunVal.includes(b.name)
          ? Validators[b.name](b.funValue)
          : Validators[b.name];
        v.push(s);
      });
    }
    return v;
  }

  addRow() {
    this.formArray.push(this.createFormGroup());
    this.ref.detectChanges();
    this.onArrayChange.emit(this.formArray.value);
  }

  removeRow(i: number) {
    this.formArray.removeAt(i);
    this.ref.detectChanges();
    this.onArrayChange.emit(this.formArray.value);
  }

  get formGroups(): UntypedFormGroup[] {
    return (this.formArray.controls as UntypedFormGroup[]) || [];
  }
  getFieldLabel(f: formBuilderData) {
    return f.title || transformTitle(f.colName);
  }
}
